(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ambasadorzy-sklep"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-amb]');
    if (!section) return;
    var track = section.querySelector('[data-amb-track]');
    if (!track) return;

    var originals = Array.prototype.slice.call(track.querySelectorAll('[data-amb-card]:not([data-amb-clone])'));
    if (originals.length < 2) return;

    var count = originals.length;
    var mq = window.matchMedia('(min-width: 800px)');
    var jumpLock = false;
    var scrollTimer;
    var infiniteReady = false;
    var ticking = false;
    var mainScale = 245.03 / 193.07;

    function isDesktop() {
      return mq.matches;
    }

    function cards() {
      return Array.prototype.slice.call(track.querySelectorAll('[data-amb-card]'));
    }

    function readScale() {
      var styles = getComputedStyle(track);
      var mainW = parseFloat(styles.getPropertyValue('--amb-main-w'));
      var sideW = parseFloat(styles.getPropertyValue('--amb-side-w'));
      if (mainW > 0 && sideW > 0) mainScale = mainW / sideW;
    }

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function clearCardMotion(card) {
      card.classList.remove('is-active');
      card.style.transform = '';
      card.style.zIndex = '';
    }

    function clearClones() {
      track.querySelectorAll('[data-amb-clone]').forEach(function (node) {
        node.parentNode.removeChild(node);
      });
      originals.forEach(function (card) {
        track.appendChild(card);
        clearCardMotion(card);
      });
      infiniteReady = false;
    }

    function setupInfinite() {
      clearClones();

      originals.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('data-amb-clone', 'append');
        clone.removeAttribute('data-amb-index');
        clearCardMotion(clone);
        track.appendChild(clone);
      });

      var first = originals[0];
      originals.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('data-amb-clone', 'prepend');
        clone.removeAttribute('data-amb-index');
        clearCardMotion(clone);
        track.insertBefore(clone, first);
      });

      infiniteReady = true;
      readScale();
    }

    function setWidth() {
      var list = cards();
      if (list.length < count * 2) return 0;
      return list[count].offsetLeft - list[0].offsetLeft;
    }

    function closestIndex() {
      var list = cards();
      var center = track.scrollLeft + track.clientWidth / 2;
      var closest = 0;
      var best = Infinity;
      list.forEach(function (card, i) {
        var c = card.offsetLeft + card.offsetWidth / 2;
        var d = Math.abs(c - center);
        if (d < best) {
          best = d;
          closest = i;
        }
      });
      return closest;
    }

    function scrollToIndex(idx, smooth) {
      var list = cards();
      var card = list[idx];
      if (!card) return;
      var left = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
      if (smooth) {
        track.scrollTo({ left: left, behavior: 'smooth' });
      } else {
        track.scrollLeft = left;
      }
    }

    function paint() {
      if (isDesktop()) {
        cards().forEach(clearCardMotion);
        return;
      }

      var list = cards();
      if (!list.length) return;

      var center = track.scrollLeft + track.clientWidth / 2;
      var step =
        list.length > 1
          ? Math.abs(list[1].offsetLeft - list[0].offsetLeft)
          : list[0].offsetWidth;
      if (step < 1) step = list[0].offsetWidth;

      var bestIdx = 0;
      var bestT = -1;

      list.forEach(function (card, i) {
        var c = card.offsetLeft + card.offsetWidth / 2;
        var dist = Math.abs(c - center);
        var raw = Math.max(0, Math.min(1, 1 - dist / step));
        var t = easeOutCubic(raw);
        var scale = 1 + (mainScale - 1) * t;

        card.style.transform = 'scale(' + scale + ')';
        card.style.zIndex = String(Math.round(1 + t * 10));
        card.classList.remove('is-active');

        if (t > bestT) {
          bestT = t;
          bestIdx = i;
        }
      });

      if (list[bestIdx]) list[bestIdx].classList.add('is-active');
    }

    function requestPaint() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        paint();
        ticking = false;
      });
    }

    function normalizeLoop() {
      if (!infiniteReady || jumpLock || isDesktop()) return;
      var idx = closestIndex();
      var width = setWidth();
      if (!width) return;

      if (idx < count) {
        jumpLock = true;
        track.scrollLeft += width;
        jumpLock = false;
        paint();
      } else if (idx >= count * 2) {
        jumpLock = true;
        track.scrollLeft -= width;
        jumpLock = false;
        paint();
      }
    }

    function onMobile() {
      setupInfinite();
      requestAnimationFrame(function () {
        var start = count + Math.min(1, count - 1);
        scrollToIndex(start, false);
        paint();
      });
    }

    function onDesktop() {
      clearClones();
      track.scrollLeft = 0;
      paint();
    }

    var modeDesktop = isDesktop();

    function applyMode(force) {
      var desk = isDesktop();
      if (!force && desk === modeDesktop) {
        if (!desk && infiniteReady) {
          scrollToIndex(closestIndex(), false);
          paint();
        }
        return;
      }
      modeDesktop = desk;
      if (desk) onDesktop();
      else onMobile();
    }

    applyMode(true);

    track.addEventListener(
      'scroll',
      function () {
        if (isDesktop() || jumpLock) return;
        requestPaint();
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(normalizeLoop, 80);
      },
      { passive: true }
    );

    track.addEventListener(
      'scrollend',
      function () {
        if (isDesktop() || jumpLock) return;
        normalizeLoop();
        paint();
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      applyMode(false);
    });

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', function () {
        applyMode(true);
      });
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(function () {
        applyMode(true);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestsellers-sklep"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-shop-best]');
    var deskMq = window.matchMedia('(min-width: 1368px)');
    var midMq = window.matchMedia('(min-width: 1000px)');

    roots.forEach(function (section) {
      var track = section.querySelector('[data-shop-best-track]');
      var strip = section.querySelector('[data-shop-best-strip]');
      if (!track || !strip) return;

      var originals = Array.prototype.slice.call(
        strip.querySelectorAll('[data-shop-best-slide]:not([data-shop-best-clone])')
      );
      var count = originals.length;
      if (count < 1) return;

      var buy = section.querySelector('[data-shop-best-buy]');
      var arrows = section.querySelector('[data-shop-best-arrows]');
      var prevBtn = section.querySelector('[data-shop-best-prev]');
      var nextBtn = section.querySelector('[data-shop-best-next]');
      var deskCenter = 0;
      var modeNow = '';
      var items = [];
      var index = 0;
      var x = 0;
      var step = 0;
      var slideW = 0;
      var infinite = false;
      var resizeTimer = 0;
      var dragging = false;
      var dragAxis = '';
      var dragMoved = false;
      var dragStartX = 0;
      var dragStartY = 0;
      var dragStartXPos = 0;
      var dragStartIndex = 0;
      var pointerId = null;
      var wheelLock = false;
      var wheelAcc = 0;

      function mode() {
        if (deskMq.matches) return 'desktop';
        if (midMq.matches) return 'tablet';
        return 'mobile';
      }

      function gapPx(rankA, rankB) {
        var lo = Math.min(rankA, rankB);
        var hi = Math.max(rankA, rankB);
        var mid = (80 / 1920) * window.innerWidth;
        var outer = (67 / 1920) * window.innerWidth;
        if (lo === 0 && hi === 1) return mid;
        return outer;
      }

      function clearClones() {
        strip.querySelectorAll('[data-shop-best-clone]').forEach(function (n) {
          n.parentNode.removeChild(n);
        });
        originals.forEach(function (slide) {
          strip.appendChild(slide);
          slide.style.marginLeft = '';
          slide.classList.remove('is-active');
          slide.removeAttribute('data-rank');
        });
        strip.style.transform = '';
        infinite = false;
        items = originals.slice();
      }

      function setupInfinite() {
        if (count < 2) {
          items = originals.slice();
          return;
        }
        clearClones();
        originals.forEach(function (slide) {
          var c = slide.cloneNode(true);
          c.setAttribute('data-shop-best-clone', 'append');
          c.classList.remove('is-active');
          strip.appendChild(c);
        });
        var first = originals[0];
        originals.forEach(function (slide) {
          var c = slide.cloneNode(true);
          c.setAttribute('data-shop-best-clone', 'prepend');
          c.classList.remove('is-active');
          strip.insertBefore(c, first);
        });
        items = Array.prototype.slice.call(strip.querySelectorAll('[data-shop-best-slide]'));
        infinite = true;
      }

      function measure() {
        if (!items.length) return;
        slideW = items[0].offsetWidth;
        if (items.length > 1) {
          step = items[1].offsetLeft - items[0].offsetLeft;
        } else {
          var styles = getComputedStyle(strip);
          var gap = parseFloat(styles.columnGap || styles.gap) || 0;
          step = slideW + gap;
        }
      }

      function posFor(i) {
        return Math.round(i * step - (track.clientWidth - slideW) / 2);
      }

      function paint(px) {
        x = px;
        strip.style.transform = 'translate3d(' + -px + 'px,0,0)';
      }

      function setActive(i) {
        index = i;
        for (var n = 0; n < items.length; n++) {
          items[n].classList.toggle('is-active', n === i);
        }
        if (buy && items[i]) {
          var card = items[i].querySelector('[data-product-url]');
          if (card) buy.setAttribute('href', card.getAttribute('data-product-url') || '#');
        }
      }

      function warpTo(i) {
        // Instant loop reset — no strip/media animation (kills the "main product jump")
        track.classList.add('is-warping');
        paint(posFor(i));
        setActive(i);
        void strip.offsetWidth;
        track.classList.remove('is-warping');
      }

      function snapTo(i) {
        i = Math.max(0, Math.min(items.length - 1, i));
        setActive(i);
        paint(posFor(i));
      }

      function wrapIfNeeded() {
        if (!infinite || count < 2) return false;
        if (index < count) {
          warpTo(index + count);
          return true;
        }
        if (index >= count * 2) {
          warpTo(index - count);
          return true;
        }
        return false;
      }

      function applyDesktop(centerIdx) {
        // Klony tylko po karuzeli; przy samej zmianie środka nie ruszamy DOM.
        if (infinite || items.length !== count) clearClones();
        items = originals.slice();
        deskCenter = centerIdx;
        items.forEach(function (slide, i) {
          var rank = Math.min(Math.abs(i - centerIdx), 2);
          slide.classList.toggle('is-active', i === centerIdx);
          slide.setAttribute('data-rank', String(rank));
          if (i === 0) {
            slide.style.marginLeft = '0px';
            return;
          }
          var prev = Math.min(Math.abs(i - 1 - centerIdx), 2);
          slide.style.marginLeft = gapPx(prev, rank) + 'px';
        });
        if (buy && items[centerIdx]) {
          var card = items[centerIdx].querySelector('[data-product-url]');
          if (card) buy.setAttribute('href', card.getAttribute('data-product-url') || '#');
        }
        layoutDesktop();
        updateArrows();
      }

      // Jeśli rząd jest szerszy niż ekran: wyrównaj do lewej i przesuń tak,
      // żeby środkowy produkt był jak najbliżej środka, bez pustych krawędzi.
      function layoutDesktop() {
        var first = items[0];
        var last = items[items.length - 1];
        var trackW = track.clientWidth;
        var contentW = last.offsetLeft + last.offsetWidth - first.offsetLeft;
        var overflow = contentW > trackW + 1;
        track.classList.toggle('is-overflow', overflow);
        if (!overflow) {
          strip.style.transform = '';
          x = 0;
          return;
        }
        var active = items[deskCenter];
        var center = active.offsetLeft - first.offsetLeft + active.offsetWidth / 2;
        paint(Math.round(Math.max(0, Math.min(contentW - trackW, center - trackW / 2))));
      }

      function updateArrows() {
        if (!arrows || !prevBtn || !nextBtn) return;
        var show = false;
        if (modeNow === 'desktop') show = track.classList.contains('is-overflow');
        else if (modeNow === 'tablet') show = count > 3;
        else show = count > 1;
        arrows.hidden = !show;
        var desk = modeNow === 'desktop';
        prevBtn.disabled = desk && deskCenter <= 0;
        nextBtn.disabled = desk && deskCenter >= count - 1;
      }

      function go(dir) {
        if (modeNow === 'desktop') {
          var c = Math.max(0, Math.min(count - 1, deskCenter + dir));
          if (c !== deskCenter) applyDesktop(c);
          return;
        }
        if (dragging || !step) return;
        wrapIfNeeded();
        snapTo(index + dir);
      }

      function startCarousel() {
        setupInfinite();
        requestAnimationFrame(function () {
          measure();
          if (!step) return;
          index = count + Math.min(1, Math.max(0, count - 1));
          track.classList.add('is-warping');
          paint(posFor(index));
          setActive(index);
          void strip.offsetWidth;
          track.classList.remove('is-warping');
        });
      }

      function applyMode(force) {
        var m = mode();
        if (!force && m === modeNow) {
          if (m === 'desktop') {
            track.classList.add('is-warping');
            applyDesktop(deskCenter);
            void strip.offsetWidth;
            track.classList.remove('is-warping');
          } else {
            measure();
            if (!step) return;
            track.classList.add('is-warping');
            paint(posFor(index));
            void strip.offsetWidth;
            track.classList.remove('is-warping');
          }
          return;
        }
        modeNow = m;
        dragging = false;
        dragAxis = '';
        track.classList.remove('is-dragging');

        if (m === 'desktop') {
          track.classList.add('is-warping');
          applyDesktop(Math.min(2, Math.max(0, count - 1)));
          void strip.offsetWidth;
          track.classList.remove('is-warping');
          return;
        }
        startCarousel();
        updateArrows();
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

      applyMode(true);

      strip.addEventListener('transitionend', function (e) {
        if (e.target !== strip || e.propertyName !== 'transform') return;
        if (mode() === 'desktop') return;
        wrapIfNeeded();
      });

      track.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });

      track.addEventListener(
        'wheel',
        function (e) {
          if (mode() === 'desktop' || dragging || !step) return;

          // only horizontal scroll-x (trackpad / shift+wheel)
          var dx = e.deltaX;
          if (e.shiftKey && !dx && e.deltaY) dx = e.deltaY;
          if (Math.abs(dx) < Math.abs(e.deltaY) && !e.shiftKey) return;
          if (!dx) return;

          e.preventDefault();
          if (wheelLock) return;

          wheelAcc += dx;
          if (Math.abs(wheelAcc) < 40) return;

          wheelLock = true;
          var dir = wheelAcc > 0 ? 1 : -1;
          wheelAcc = 0;

          var target = Math.max(0, Math.min(items.length - 1, index + dir));
          snapTo(target);

          setTimeout(function () {
            wheelLock = false;
          }, 320);
        },
        { passive: false }
      );

      track.addEventListener(
        'pointerdown',
        function (e) {
          if (mode() === 'desktop') return;
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          dragging = true;
          dragAxis = '';
          dragMoved = false;
          pointerId = e.pointerId;
          dragStartX = e.clientX;
          dragStartY = e.clientY;
          dragStartXPos = x;
          dragStartIndex = index;
        },
        true
      );

      track.addEventListener(
        'pointermove',
        function (e) {
          if (!dragging || (pointerId !== null && e.pointerId !== pointerId)) return;
          var dx = e.clientX - dragStartX;
          var dy = e.clientY - dragStartY;

          if (!dragAxis) {
            if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
            if (Math.abs(dy) > Math.abs(dx)) {
              dragging = false;
              return;
            }
            dragAxis = 'x';
            track.classList.add('is-dragging');
            try {
              track.setPointerCapture(e.pointerId);
            } catch (err) {}
          }

          if (dragAxis !== 'x') return;
          if (Math.abs(dx) > 6) dragMoved = true;
          // finger 1:1 — no setActive here (that was the lag)
          paint(dragStartXPos - dx);
        },
        true
      );

      function endDrag() {
        if (!dragging) return;
        var wasX = dragAxis === 'x';
        dragging = false;
        dragAxis = '';
        pointerId = null;
        track.classList.remove('is-dragging');
        if (!wasX || !step) return;

        var moved = x - dragStartXPos;
        var target = dragStartIndex;
        if (moved > step * 0.2) target = dragStartIndex + 1;
        else if (moved < -step * 0.2) target = dragStartIndex - 1;

        target = Math.max(0, Math.min(items.length - 1, target));
        snapTo(target);
      }

      track.addEventListener('pointerup', endDrag, true);
      track.addEventListener('pointercancel', endDrag, true);

      track.addEventListener(
        'click',
        function (e) {
          if (!dragMoved) return;
          e.preventDefault();
          e.stopPropagation();
          dragMoved = false;
        },
        true
      );

      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          applyMode(false);
        }, 120);
      });

      function onMq() {
        applyMode(true);
      }
      if (typeof deskMq.addEventListener === 'function') {
        deskMq.addEventListener('change', onMq);
        midMq.addEventListener('change', onMq);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Panel wyszukiwania pod headerem. Ikona lupy (header + mobile menu) to link do /search jako fallback.
  (function () {
    var CLOSE_MS = 320;

    document.querySelectorAll('[data-header-search]').forEach(function (panel) {
      if (panel.dataset.bound) return;
      panel.dataset.bound = 'true';

      var root = panel.closest('[data-mobile-menu-root]') || document;
      var input = panel.querySelector('[data-header-search-input]');
      var triggers = root.querySelectorAll('[data-header-search-toggle]');
      var lastTrigger = null;
      var closeTimer = 0;

      function isOpen() {
        return !panel.hidden && panel.classList.contains('is-open');
      }

      function setExpanded(value) {
        triggers.forEach(function (t) { t.setAttribute('aria-expanded', String(value)); });
      }

      function open(trigger) {
        window.clearTimeout(closeTimer);
        lastTrigger = trigger || null;
        panel.hidden = false;
        void panel.offsetWidth;
        panel.classList.add('is-open');
        setExpanded(true);
        if (input) input.focus({ preventScroll: true });
      }

      function close(restoreFocus) {
        if (panel.hidden) return;
        panel.classList.remove('is-open');
        setExpanded(false);
        window.clearTimeout(closeTimer);
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        closeTimer = window.setTimeout(function () { panel.hidden = true; }, reduce ? 0 : CLOSE_MS);
        if (!restoreFocus) return;
        // Trigger z mobile menu znika razem z menu — wtedy fokus na hamburger.
        var target = lastTrigger && lastTrigger.offsetParent !== null ? lastTrigger : root.querySelector('[data-mobile-menu-toggle]');
        if (target) target.focus();
      }

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
          event.preventDefault();
          if (isOpen()) {
            close(false);
            return;
          }
          // Z mobile menu: zamknij menu i pokaż panel pod headerem.
          var menu = trigger.closest('[data-mobile-menu]');
          var toggle = root.querySelector('[data-mobile-menu-toggle]');
          if (menu && toggle && menu.classList.contains('is-open')) toggle.click();
          open(trigger);
        });
      });

      panel.addEventListener('click', function (event) {
        if (event.target.closest('[data-header-search-close]')) close(true);
      });

      // Podpowiedzi: /search/suggest renderuje sections/predictive-search.liquid.
      var results = panel.querySelector('[data-header-search-results]');
      var status = panel.querySelector('[data-header-search-status]');
      var searchRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var debounce = 0;
      var controller = null;

      function announce(message) {
        if (status) status.textContent = message;
      }

      function clearResults() {
        if (controller) controller.abort();
        if (results) {
          results.innerHTML = '';
          results.classList.remove('is-loading');
        }
        announce('');
      }

      function suggest(terms) {
        if (!results) return;
        if (controller) controller.abort();
        controller = new AbortController();
        results.classList.add('is-loading');

        var url = new URL(searchRoot + 'search/suggest', window.location.origin);
        url.searchParams.set('q', terms);
        url.searchParams.set('section_id', 'predictive-search');
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[options][unavailable_products]', 'last');

        fetch(url.toString(), { signal: controller.signal })
          .then(function (response) {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then(function (html) {
            // Odpowiedź dla nieaktualnej frazy — pomiń.
            if (!input || input.value.trim() !== terms) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var next = doc.querySelector('.header-search-results');
            results.innerHTML = next ? next.outerHTML : '';
            results.classList.remove('is-loading');
            var count = next ? parseInt(next.getAttribute('data-predictive-count'), 10) || 0 : 0;
            announce(count ? 'Znaleziono produktów: ' + count + '.' : 'Brak wyników.');
          })
          .catch(function (error) {
            if (error && error.name === 'AbortError') return;
            results.classList.remove('is-loading');
          });
      }

      if (input) {
        input.addEventListener('input', function () {
          window.clearTimeout(debounce);
          var terms = input.value.trim();
          if (terms.length < 2) {
            clearResults();
            return;
          }
          debounce = window.setTimeout(function () { suggest(terms); }, 250);
        });

        // Strzałka w dół z pola → pierwszy wynik.
        input.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowDown' || !results) return;
          var first = results.querySelector('a');
          if (!first) return;
          event.preventDefault();
          first.focus();
        });
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && isOpen()) close(true);
      });

      document.addEventListener('click', function (event) {
        if (!isOpen()) return;
        if (panel.contains(event.target) || event.target.closest('[data-header-search-toggle]')) return;
        close(false);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner-sklep"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-shop-hero]');
    if (!root) return;

    var track = root.querySelector('[data-shop-hero-track]');
    var slides = root.querySelectorAll('[data-shop-hero-slide]');
    var dots = root.querySelectorAll('[data-shop-hero-dot]');
    if (!track || slides.length < 2) return;

    var index = 0;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(' + index * -100 + '%)';
      dots.forEach(function (dot, di) {
        var on = di === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(Number(dot.getAttribute('data-shop-hero-dot')) || 0);
      });
    });

    var startX = 0;
    var deltaX = 0;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      deltaX = 0;
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      deltaX = e.touches[0].clientX - startX;
    }, { passive: true });
    track.addEventListener('touchend', function () {
      if (Math.abs(deltaX) < 40) return;
      goTo(index + (deltaX < 0 ? 1 : -1));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-hero]');
    if (!root) return;
    var track = root.querySelector('[data-hero-track]');
    var slides = root.querySelectorAll('[data-hero-slide]');
    var dots = root.querySelectorAll('[data-hero-dot]');
    if (slides.length <= 1) return;

    var current = 0;
    var timer;
    var INTERVAL = 5000;

    function goTo(i) {
      current = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, idx) {
        d.setAttribute('aria-current', idx === current ? 'true' : 'false');
      });
    }

    function start() {
      stop();
      timer = setInterval(function () { goTo(current + 1); }, INTERVAL);
    }

    function stop() { if (timer) clearInterval(timer); }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        goTo(parseInt(d.getAttribute('data-hero-dot'), 10));
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    goTo(0);
    start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maradona"] && !Shopify.designMode) return;
  try {
    
  /* Blok javascript nie renderuje Liquida, więc sekcje szukamy po klasie,
     a nie po section.id. Inicjalizacja też po przeładowaniu w edytorze motywu. */
  (function () {
  function initMara(root) {
    if (!root || root.hasAttribute('data-mara-ready')) return;
    root.setAttribute('data-mara-ready', '');
    var track = root.querySelector('[data-mara-track]');
    if (!track) return;

    var deskMq = window.matchMedia('(min-width: 786px)');
    var cards = [];
    var dragging = false;
    var dragMoved = false;
    var startX = 0;
    var startScroll = 0;

    function list() {
      return Array.prototype.slice.call(track.querySelectorAll('[data-mara-card]'));
    }

    function isDesk() {
      return deskMq.matches;
    }

    function setActive(i) {
      cards.forEach(function (card, n) {
        card.classList.toggle('is-active', n === i);
      });
    }

    function closest() {
      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + track.clientWidth / 2;
      var best = 0;
      var dist = Infinity;
      cards.forEach(function (card, i) {
        var r = card.getBoundingClientRect();
        var c = r.left + r.width / 2;
        var d = Math.abs(c - center);
        if (d < dist) {
          dist = d;
          best = i;
        }
      });
      return best;
    }

    function scrollTo(i, smooth) {
      var card = cards[i];
      if (!card) return;
      var trackRect = track.getBoundingClientRect();
      var cardRect = card.getBoundingClientRect();
      var left =
        track.scrollLeft +
        (cardRect.left - trackRect.left) -
        (track.clientWidth - card.offsetWidth) / 2;
      if (smooth) {
        track.scrollTo({ left: left, behavior: 'smooth' });
      } else {
        track.scrollLeft = left;
      }
      setActive(i);
    }

    function onScroll() {
      if (isDesk()) return;
      setActive(closest());
    }

    function bindDrag() {
      track.addEventListener('pointerdown', function (e) {
        if (isDesk() || e.button !== 0) return;
        dragging = true;
        dragMoved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(e.pointerId);
      });

      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 6) dragMoved = true;
        track.scrollLeft = startScroll - dx;
      });

      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        if (e && track.hasPointerCapture(e.pointerId)) {
          track.releasePointerCapture(e.pointerId);
        }
        if (!isDesk()) scrollTo(closest(), true);
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('click', function (e) {
        if (!dragMoved) return;
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }, true);
    }

    var centered = false;
    var wasDesk = isDesk();

    function start(force) {
      cards = list();
      if (!cards.length) return;
      var desk = isDesk();
      if (desk) {
        cards.forEach(function (card) {
          card.classList.add('is-active');
        });
        wasDesk = true;
        return;
      }
      if (!force && centered && !wasDesk) return;
      var mid = Math.floor(cards.length / 2);
      requestAnimationFrame(function () {
        scrollTo(mid, false);
      });
      centered = true;
      wasDesk = false;
    }

    function onMqChange() {
      if (!root.isConnected) return;
      start(true);
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    bindDrag();
    start(true);
    if (deskMq.addEventListener) {
      deskMq.addEventListener('change', onMqChange);
    } else if (deskMq.addListener) {
      deskMq.addListener(onMqChange);
    }
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.mara'), initMara);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mizu-kids"] && !Shopify.designMode) return;
  try {
    
  // Blok JS nie renderuje Liquid — inicjalizacja po data-atrybucie.
  (function () {
    // Poniżej 1250px produkty są nieskończonym sliderem (transform + klony kart).
    var deskMq = window.matchMedia('(min-width: 1250px)');

    function init(root) {
      var track = root.querySelector('[data-kids-track]');
      var strip = root.querySelector('[data-kids-strip]');
      if (!track || !strip || track.hasAttribute('data-kids-ready')) return;
      track.setAttribute('data-kids-ready', '');

      var originals = Array.prototype.slice.call(strip.querySelectorAll('[data-kids-card]'));
      var count = originals.length;
      if (!count) return;

      var items = originals.slice();
      // Po 2 komplety klonów z każdej strony — przy żadnym przeciągnięciu nie widać pustego końca.
      var SETS = 2;
      var base = 0;
      var looped = false;
      var active = false;
      var index = 0;
      var x = 0;
      var drag = null;
      var dragMoved = false;
      var resizeTimer = 0;

      function cloneCard(card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('data-kids-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        clone.removeAttribute('data-shopify-editor-block');
        return clone;
      }

      // Oryginały w środku: items[base .. base + count - 1].
      function addClones() {
        if (looped || count < 2) return;
        var first = originals[0];
        for (var n = 0; n < SETS; n++) {
          originals.forEach(function (card) {
            strip.appendChild(cloneCard(card));
          });
          originals.forEach(function (card) {
            strip.insertBefore(cloneCard(card), first);
          });
        }
        items = Array.prototype.slice.call(strip.querySelectorAll('[data-kids-card]'));
        base = count * SETS;
        looped = true;
      }

      function removeClones() {
        strip.querySelectorAll('[data-kids-clone]').forEach(function (clone) {
          clone.remove();
        });
        items = originals.slice();
        base = 0;
        looped = false;
      }

      function posFor(i) {
        var card = items[i];
        return card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
      }

      function step() {
        return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth;
      }

      function paint(px) {
        x = px;
        strip.style.transform = 'translate3d(' + -px + 'px, 0, 0)';
      }

      // Natychmiastowe przestawienie bez animacji.
      function jump(px) {
        track.classList.add('is-warping');
        paint(px);
        void strip.offsetWidth;
        track.classList.remove('is-warping');
      }

      // Ten sam produkt wśród oryginałów.
      function toMiddle(i) {
        if (!looped) return i;
        return base + (((i - base) % count) + count) % count;
      }

      // Po każdym przesunięciu przestaw z klona na oryginał (niewidocznie, ta sama karta).
      function wrap() {
        var i = toMiddle(index);
        if (i === index) return;
        index = i;
        jump(posFor(index));
      }

      function snapTo(i) {
        index = Math.max(0, Math.min(items.length - 1, i));
        var target = posFor(index);
        var still = Math.abs(target - x) < 1;
        paint(target);
        if (still) wrap();
      }

      function currentX() {
        var t = getComputedStyle(strip).transform;
        if (!t || t === 'none') return x;
        return -new DOMMatrixReadOnly(t).m41;
      }

      function nearest(px) {
        var best = 0;
        var dist = Infinity;
        for (var i = 0; i < items.length; i++) {
          var d = Math.abs(posFor(i) - px);
          if (d < dist) {
            dist = d;
            best = i;
          }
        }
        return best;
      }

      strip.addEventListener('transitionend', function (e) {
        if (e.target !== strip || e.propertyName !== 'transform' || drag) return;
        wrap();
      });

      track.addEventListener('pointerdown', function (e) {
        if (!active || (e.pointerType === 'mouse' && e.button !== 0)) return;
        // Złap slider tam, gdzie akurat jest (także w trakcie animacji).
        var px = currentX();
        var i = nearest(px);
        var m = toMiddle(i);
        px += posFor(m) - posFor(i);
        index = m;
        jump(px);
        drag = {
          id: e.pointerId,
          x0: e.clientX,
          y0: e.clientY,
          px0: px,
          t0: Date.now(),
          axis: ''
        };
        dragMoved = false;
      });

      track.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.x0;
        var dy = e.clientY - drag.y0;
        if (!drag.axis) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) {
            drag = null;
            snapTo(index);
            return;
          }
          drag.axis = 'x';
          track.classList.add('is-dragging');
          try {
            track.setPointerCapture(e.pointerId);
          } catch (err) {}
        }
        dragMoved = true;
        paint(drag.px0 - dx);
      });

      function endDrag(e) {
        if (!drag || (e && e.pointerId !== drag.id)) return;
        var d = drag;
        drag = null;
        track.classList.remove('is-dragging');
        if (d.axis !== 'x') {
          snapTo(index);
          return;
        }
        var moved = x - d.px0;
        var s = step();
        var n = Math.round(moved / s);
        // Krótkie, szybkie machnięcie też przesuwa o jedną kartę.
        var fast = Date.now() - d.t0 < 300 && Math.abs(moved) > 30;
        if (n === 0 && (Math.abs(moved) > s * 0.15 || fast)) n = moved > 0 ? 1 : -1;
        snapTo(index + n);
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      // Tylko utrata przechwycenia przez sam slider. Przy dotyku przeglądarka najpierw przypina palec
      // do karty; przepięcie na slider wysyła lostpointercapture z karty, które tu bąbelkuje.
      track.addEventListener('lostpointercapture', function (e) {
        if (e.target === track) endDrag(e);
      });

      track.addEventListener('click', function (e) {
        if (!dragMoved) return;
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }, true);

      track.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });

      // Tab na karcie: pokaż ją na środku. Przeglądarka może przewinąć kontener — zerujemy to.
      track.addEventListener('focusin', function (e) {
        if (!active) return;
        var i = items.indexOf(e.target.closest('[data-kids-card]'));
        if (i > -1) snapTo(i);
      });

      track.addEventListener('scroll', function () {
        if (active && track.scrollLeft) track.scrollLeft = 0;
      });

      function start() {
        drag = null;
        track.classList.remove('is-dragging');
        if (deskMq.matches) {
          active = false;
          removeClones();
          strip.style.transform = '';
          track.classList.remove('is-ready');
          return;
        }
        active = true;
        addClones();
        track.classList.add('is-ready');
        track.scrollLeft = 0;
        var mid = count > 2 ? 2 : Math.min(1, count - 1);
        index = base + mid;
        jump(posFor(index));
      }

      start();

      if (deskMq.addEventListener) {
        deskMq.addEventListener('change', start);
      } else if (deskMq.addListener) {
        deskMq.addListener(start);
      }

      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (active && !drag) jump(posFor(index));
        }, 120);
      });
    }

    document.querySelectorAll('[data-kids]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-kids]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
